// extracted by mini-css-extract-plugin
export default {"advancedSection":"styles_advancedSection__mDMtw"};